module.exports = __webpack_public_path__ + "img/meter.fe1ad472.svg";